import Repository from '@/repositories/marketing'
const resource = '/forms'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    delete(config){
        return Repository.delete(`forms/bulk_delete.json`,config)
    }
}
